import { useEffect } from 'react';

import { ScriptEnvironment } from 'app/components/scripts/helpers';
import { gaInit } from 'app/services/google-analytics';
import Script from 'app/utils/lib/script';

// GTM script content as a constant
/* eslint-disable @typescript-eslint/naming-convention */
const GTM_SCRIPT_CONTENT = `
(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-W8B29CH');
`;

export const GoogleTagManagerScript = () => {
  useEffect(() => {
    gaInit();
  }, []);

  return (
    <Script
      dangerouslySetInnerHTML={{ __html: GTM_SCRIPT_CONTENT }}
      environment={ScriptEnvironment.ProductionOnly}
      id="google-tag-manager"
      serviceName="Google Tag Manager"
      strategy="beforeInteractive"
    />
  );
};

export default GoogleTagManagerScript;
